import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class Produccion {
    static typeSearch = "local" //online || local
    static rules = {
        Requerido: [(value) => !!value || 'El campo obligatorio'],
        Porcentaje:[(value)=> Number(value) >= 0 && Number(value) <=100 || "Debe ser un porcentaje valido"]
    }

    static statusList =  [
      {id:"P", name:"Pendiente"},
      {id:"A", name:"Aplicado"},
      {id:"F", name:"Finalizado"},
      {id:"C", name:"Cancelado"},
      /*{id:"Producto-SSal",name:"Producto de solo salidas"}*/
    ]

    static types = [
      {id:"A", name:"Abierta"},
      {id:"O", name:"Desde orden de compra"},
    ]
    constructor(data = null) {
        this.Id = (data?.id) ? data.id : null;
        this.sts = (data?.sts) ? data.sts : "P";
        this.amc = (data?.amc) ? data.amc : "";
        this.ame = (data?.ame)?data.ame:"",
        this.ams = (data?.ams)?data.ams:"",
        this.mmt = (data?.mmt) ? data?.mmt: '';
        //this.ocm = (data?.ocm)? data?.ocm:null;
        //this.dsc = (data?.dsc) ? data?.dsc: '';
        this.Tenant = (data?.Tenant) ? data.Tenant : store.getters.getFirebaseApp.tenant;
        this.adq = (data?.adq) ? data.adq : []
        this.prd = (data?.prd) ? data.prd : []
        this.dpt = (data?.dpt) ? data.dpt : []
    }



    static getPropertyModel() {
        return this;
    }

    static getStatusList(){
      return this.statusList;
    }

    static getTypes(){
      return this.types;
    }

    static async getOrdeneCompra() {

        const firestore = store.getters.getFirebaseApp.firestore
        const data = await firestore
            .queryBuilder("AMC_Presentaciones",
                [
                ]
            )
        if (data.empty) {
            return [];
        } else {
            let doc = data.docs.map(doc => { return { Id: doc.ref.id, ...doc.data() } });
            return doc;
        }
    }
    static getRules() {
        return this.rules;
    }



}